import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import '../App.css'; // Certifique-se de que o CSS com .rounded-avatar está aqui

function Home() {
  const [editions, setEditions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const fetchEditions = async () => {
      if (!hasMore || loading) return;

      setLoading(true);
      try {
        const response = await axios.get(`https://scoreboard-j6oz.onrender.com/editions/summary?page=${page}`);

        if (response.data.length === 0) {
          setHasMore(false);
        } else {
          setEditions(prevEditions => {
            const existingKeys = new Set(prevEditions.map(e => `${e.number}-${e.dateEvent}`));
            const newEditions = response.data.filter(
              edition => !existingKeys.has(`${edition.number}-${edition.dateEvent}`)
            );
            return [...prevEditions, ...newEditions];
          });
        }
      } catch (error) {
        console.error('Erro ao buscar edições:', error);
      }
      setLoading(false);
    };

    fetchEditions();
  }, [page]);

  useEffect(() => {
    const handleScroll = () => {
      if (!hasMore || loading) return;

      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollPosition = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement?.scrollTop || 0);

      if (documentHeight - windowHeight - scrollPosition < 100) {
        setPage(prevPage => prevPage + 1);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [loading, hasMore]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <div className="App">
      <nav className="navbar navbar-dark bg-primary">
        <div className="container">
          <button className="navbar-toggler" type="button" onClick={toggleMenu}>
            <span className="navbar-toggler-icon"></span>
          </button>
          <a className="navbar-brand" href="#"><b>Rhymes Score</b></a>
          <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
            <ul className="navbar-nav ml-auto">
              <li className="nav-item"><Link className="nav-link" to="/">Home</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/topbigfour">Top 5 - Big Four - São Paulo SP</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/rankhype">Ranking do Hype - Big Four - São Paulo SP</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/about">Sobre Nós</Link></li>
            </ul>
          </div>
        </div>
      </nav>

      <div className="main-content">
        <div className="py-5">
          <div className="container">
            <div className="row"><div className="col-md-12"><h2 className="editions-title">Últimas Edições</h2></div></div>
          </div>
        </div>

        {editions.map((edition, index) => (
          <div className="py-3" key={index}>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card bg-light p-3">
                    <div className="row mb-4">
                      <div className="col-3 d-flex flex-column align-items-center">
                        <ul style={{ listStyleType: 'none', padding: 0 }}>
                          {edition.winningTeam?.mcs?.map((mc, mcIndex) => (
                            <li key={mcIndex} className="text-center">
                              <Link to={`/profile/${mc.nickName}`}>
                                <img className="rounded-avatar d-block mx-auto" src={mc.photo} alt="Profile" />
                              </Link>
                              <p className="mb-0 mc-name">{mc.nickName}</p>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="col-9">
                        {/* 1. Nome da Organização (Já ajustamos antes) */}
                        <h4 className="card-title urban-title">{edition.organizationName}</h4>

                        {/* 2. Localidade (Mapa) + Nova Fonte */}
                        <p className="card-text info-text d-flex align-items-center" style={{ gap: '8px' }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                          </svg>
                          <span>{edition.city} - {edition.state}</span>
                        </p>

                        {/* 3. Tipo de Edição (Microfone) + Nova Fonte */}
                        <p className="card-text info-text d-flex align-items-center" style={{ gap: '8px' }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                            <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                            <line x1="12" y1="19" x2="12" y2="23"></line>
                            <line x1="8" y1="23" x2="16" y2="23"></line>
                          </svg>
                          <span>{edition.format}</span>
                        </p>

                        {/* 4. Número da Edição (Hashtag) + Link azul */}
                      <Link className="edition-number-link" to={`/edition/organization/${edition.organizationName}/number/${edition.number}`}>
                        <p className="card-text info-text d-flex align-items-center" style={{ gap: '8px', color: '#007bff' }}>
                          
                          {/* Mudei o stroke para #555 (Cinza igual aos outros ícones) */}
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                            <line x1="7" y1="7" x2="7.01" y2="7"></line>
                          </svg>
                          
                          <span>nº {edition.number}</span>
                        </p>
                      </Link>

                        {/* 5. Data (Calendário) + Nova Fonte */}
                        <p className="card-text info-text d-flex align-items-center" style={{ gap: '8px' }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                          </svg>
                          <span>{new Date(edition.dateEvent).toLocaleDateString()}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        {loading && (
          <div className="text-center py-3">
            <ClipLoader color="#000" loading={loading} size={35} />
          </div>
        )}

        {!hasMore && (
          <div className="text-center py-3">
            <p>🚀 Todas as edições foram carregadas!</p>
          </div>
        )}
      </div>

      <footer>
        <div className="text-center"><p className="mb-0">© 2024 Rhymes Score. All rights reserved</p></div>
      </footer>
    </div>
  );
}

export default Home;
